import React from 'react'
import { ISO_CODES, DEFAULT_LANG } from '../../utils/countries'
import { CONTINENTS } from '../../utils/continents'

import FlagMenuItem from '../FlagMenuItem'
import Menu from '@mui/material/Menu'

function matchIsArray(value, filled) {
  const isArray = Array.isArray(value)
  return filled ? isArray && value.length > 0 : isArray
}

function getOnlyCountries(countries, onlyCountries) {
  return countries.filter((isoCode) => {
    return onlyCountries.includes(isoCode)
  })
}

function sortedPreferredCountries(countries, preferredCountries) {
  return [...new Set(preferredCountries.concat(countries))]
}

function sortAlphabeticallyCountryCodes(countryCodes, displayNames) {
  return [...countryCodes].sort((countryCodeA, countryCodeB) => {
    const countryA = displayNames.of(countryCodeA)
    const countryB = displayNames.of(countryCodeB)
    return countryA.localeCompare(countryB)
  })
}

function getCountriesOfContinents(continents) {
  return continents.flatMap((continentCode) => {
    return CONTINENTS[continentCode]
  })
}

function excludeCountries(countries, excludedCountries) {
  if (matchIsArray(excludedCountries, true)) {
    return countries.filter((isoCode) => {
      return !excludedCountries.includes(isoCode)
    })
  }
  return countries
}

function filterCountries(countries, options) {
  const { onlyCountries, excludedCountries, continents, preferredCountries } = options

  if (matchIsArray(onlyCountries, true)) {
    const filteredCountries = getOnlyCountries(countries, onlyCountries)
    return matchIsArray(preferredCountries, true)
      ? sortedPreferredCountries(filteredCountries, preferredCountries)
      : filteredCountries
  }

  const theCountries = matchIsArray(continents, true)
    ? getCountriesOfContinents(continents)
    : countries

  const sortedCountries = matchIsArray(preferredCountries, true)
    ? sortedPreferredCountries(theCountries, preferredCountries)
    : theCountries

  return matchIsArray(excludedCountries, true)
    ? excludeCountries(sortedCountries, excludedCountries)
    : sortedCountries
}

function getDisplayNames(lang = DEFAULT_LANG) {
  try {
    return new Intl.DisplayNames(lang, {
      type: 'region',
    })
  } catch (error) {
    console.log(error)
    return new Intl.DisplayNames(DEFAULT_LANG, {
      type: 'region',
    })
  }
}

function FlagsMenu({
  anchorEl,
  isoCode,
  onSelectCountry,
  excludedCountries = [],
  onlyCountries = [],
  langOfCountryName = DEFAULT_LANG,
  continents = [],
  preferredCountries = [],
  className,
  flagSize = 'small',
  ...rest
}) {
  const displayNames = React.useMemo(() => {
    return getDisplayNames(langOfCountryName)
  }, [langOfCountryName])
  const ISO_CODES_SORTED = sortAlphabeticallyCountryCodes(ISO_CODES, displayNames)
  const countriesFiltered = filterCountries(ISO_CODES_SORTED, {
    onlyCountries,
    excludedCountries,
    continents,
    preferredCountries,
  })

  return (
    <Menu
      anchorEl={anchorEl}
      open={anchorEl}
      id="select-country"
      className={`MuiTelInput-Menu ${className || ''}`}
      MenuListProps={{
        role: 'listbox',
        'aria-activedescendant': isoCode ? `country-${isoCode}` : '',
        'aria-labelledby': 'select-country',
      }}
      {...rest}
    >
      {countriesFiltered.map((isoCodeItem) => {
        return (
          <FlagMenuItem
            onSelectCountry={onSelectCountry}
            key={isoCodeItem}
            isoCode={isoCodeItem}
            countryName={displayNames.of(isoCodeItem)}
            selected={isoCodeItem === isoCode}
            id={`country-${isoCodeItem}`}
            flagSize={flagSize}
          />
        )
      })}
    </Menu>
  )
}

export default FlagsMenu
